/**
 * @desc 事件列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode?: string;
  /** baseId */
  baseId?: string;
  /** current */
  current?: number;
  /** endTime */
  endTime?: string;
  /** factoryCode */
  factoryCode?: string;
  /** findBy */
  findBy?: number;
  /** name */
  name?: string;
  /** pageSize */
  pageSize?: number;
  /** professionalId */
  professionalId?: number;
  /** sectionId */
  sectionId?: string;
  /** startTime */
  startTime?: string;
  /** state */
  state?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.Page<defs.EventListResponse>>> {
  return defHttp.get({
    url: '/web/event/list',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.Page<defs.EventListResponse>>> {
  return defHttp.get({
    url: '/mock/web/event/list',

    params,
  });
}
